// extracted by mini-css-extract-plugin
export default {"logoWrapper":"styles_logoWrapper__LCXuE","logoSvg":"styles_logoSvg__ebU8K"};